import { useEffect, useState } from "react"
import { auth } from "@/lib/firebase"
import { onAuthStateChanged } from "firebase/auth"

export const useAuthReady = () => {
  const [authReady, setAuthReady] = useState(false)

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async user => {
      if (user) {
        try {
          await user.getIdToken()
        } catch (e) {
          console.warn("Token fetch failed", e)
        }
      }
      setAuthReady(true)
    })

    return () => unsubscribe()
  }, [])

  return authReady
}
